import { h, Component } from 'preact'
import ProductGrid from './ProductGrid'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const API_URL = document.querySelector('link[rel="https://api.w.org/"]').href

class Compare extends Component {
  state = {
    products: [],
    count: 0
  }
  componentDidMount() {
    const items = JSON.parse(window.localStorage.getItem('compare')) || []
    if (items.length) {
      window
        .fetch(`/wp-json/wp/v2/products?include=${items.join(',')}`, {
          credentials: 'same-origin'
        })
        .then(r => r.json())
        .then(r => this.setState({ products: r }))
        .catch(e => console.error(e))
    }
    this.setProductCount()
  }
  setProductCount() {
    const items = JSON.parse(window.localStorage.getItem('compare')) || []
    this.setState({
      count: items.length
    })
  }
  render() {
    const { products, count } = this.state
    return (
      <section style="width: 100%;">
        <h2
          style={{
            display: 'inline-block',
            width: '100%',
            textAlign: 'center'
          }}
        >
          Vergelijk
          {count > 0 ? (
            <div class="c-single-product__count">
              {count} {count === 1 ? 'product' : 'producten'}
            </div>
          ) : null}
        </h2>
        {count ? (
          <ProductGrid
            products={products}
            setProductCount={() => this.setProductCount()}
          />
        ) : (
          <div
            style={{
              display: 'inline-block',
              marginRight: '1rem',
              width: '100%',
              textAlign: 'center'
            }}
            dangerouslySetInnerHTML={{ __html: this.props.ifEmpty }}
          />
        )}
      </section>
    )
  }
}

export default Compare



// WEBPACK FOOTER //
// ./src/js/compare/components/Compare.js